import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-text",
  "use": "fileType-text-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"fileType-text\"><defs><symbol id=\"fileType-text_file-text\" data-name=\"file-text\" viewBox=\"0 0 20 20\"><path d=\"M15.77,0H0V20H20V4.23Zm-3,7.43H10.38v6.21H9.3V7.43H6.91V6.5h5.85Zm3-3.06V.28l4.08,4.08Z\" fill=\"#00a0e9\" /></symbol></defs><title>fileType-text</title><g id=\"fileType-text_图层_2\" data-name=\"图层 2\"><g id=\"fileType-text_图层_1-2\" data-name=\"图层 1\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-text_file-text\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-text.svg
// module id = PY3c
// module chunks = 264